<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup"
               [disableEntityLocalisation]="!isLocalisedType" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.preparation-modifier.edit.formation.details', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="type" [(ngModel)]="model.data.type"
                                                        [readonly]="fixedType" [readonlyOnEdit]="true"
                                                        (onSelect)="selectType()">
                            <wbo-select-options>
                                <wbo-select-option [value]="MetaTagType.PREPARATION" label="wbo.preparation-modifier.option.modifier-type.preparation"></wbo-select-option>
                                <wbo-select-option [value]="MetaTagType.PREPARED_MESSAGE" label="wbo.preparation-modifier.option.modifier-type.message"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="isValuedType">
                <fui-column>
                    <wbo-edit-grid [data]="model.data.values" [editable]="true"
                                   [removable]="true" [entityPath]="'values'" [reorderable]="true">
                        <wbo-text-column field="name" [editable]="true"></wbo-text-column>
                        <wbo-edit-grid-add-row [identifierField]="'metaTagDefinitionId'">
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
